(function (t) {
// ro
t.add("Previous", "Pagina anterioara", "KnpPaginatorBundle", "ro");
t.add("Next", "Pagina urmatoare", "KnpPaginatorBundle", "ro");
})(Translator);
